export default __webpack_public_path__ + "static/P_SearchThumb_IN-3010-663b309776212e92a447ca3ae9f97db0.webp";